<div class="page-container">
    <ng-container header>
        <div class="header-container">
            <ham-page-header
                [title]="'aumico_organization_settings_closing_workflow_configuration_page_header'"
                [hasBackButton]="true"
                [backButtonRoute]="['../overview']"
            ></ham-page-header>
        </div>
    </ng-container>

    <ng-container content>
        <div class="content-container">
            <workflow-configurator
                [area]="'CLOSING_PROCESS'"
                [workflowDto]="savedWorkflow || workflowAsTemplate"
                (onEditSection)="updateSection($event)"
                (onWorkflowFormChange)="onWorkflowFormValueChange($event)"
            ></workflow-configurator>
        </div>
    </ng-container>

    <ng-template #footerTemplate>
        <aum-action-bar-pure nextButtonText="{{'aumico_button_save' | i18next}}" [nextButtonAction]="nextButtonAction">
        </aum-action-bar-pure>
    </ng-template>
</div>
